var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgActiveUserInbox = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00016 5.33333L6.52096 7.01387C7.41669 7.61102 8.58363 7.61102 9.47936 7.01387L12.0002 5.33333M4.00016 14H12.0002C13.4729 14 14.6668 12.8061 14.6668 11.3333V4.66667C14.6668 3.19391 13.4729 2 12.0002 2H4.00016C2.5274 2 1.3335 3.19391 1.3335 4.66667V11.3333C1.3335 12.8061 2.5274 14 4.00016 14Z",
    stroke: "#181D27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgActiveUserInbox);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/active_user_inbox.04973f8c1fac8f5137e282e6879faec2.svg";